import { toNumberOrZero } from '~/utils/functions';
import { DadosIbsCbsCliente, EmpresaIbsCbsProps } from '../protocols';
import { servicesIbsCbs } from '../services';

export type IbsCbs = {
  codIbsCbs: number;
  perAliqCbs: number;
  perRedCbs: number;
  valRedSocial: number;
  cstIbsCbs: string;
  desClassifTrib: string;
};

const dataDefault: DadosIbsCbsCliente = {
  cod_ibs_cbs: null,
  per_aliq_cbs: 0,
  per_red_cbs: 0,
  val_red_social: 0,
  per_aliq_ibs_est: 0,
  per_aliq_ibs_mun: 0,
  per_red_ibs: 0,
  cst_ibs_cbs: '',
  des_classif_trib_ibs_cbs: '',
};

export const obterDadosIbsCbsCliente = async (
  codIbsCbs: number,
  codCidadeConsumo: number,
  desSigla: string,
  empresa: EmpresaIbsCbsProps,
): Promise<DadosIbsCbsCliente> => {
  if (!Number.isFinite(codIbsCbs) || codIbsCbs <= 0) return dataDefault;

  const reg = await servicesIbsCbs.getIbsCbsPorCodigo(codIbsCbs);

  if (!reg) return dataDefault;

  const uf = String(desSigla).toUpperCase();

  // 2) Regras IBS (servidor calcula; frontend apenas consome)
  const [perAliqIbsEstBase, perAliqIbsMunBase, perRedIbsBase] =
    await Promise.all([
      servicesIbsCbs.retornaIBSEst(codIbsCbs, uf),
      servicesIbsCbs.retornaIBSMun(codIbsCbs, codCidadeConsumo, uf),
      servicesIbsCbs.retornaRedIBS(codIbsCbs, uf),
    ]);

  // 3) Overrides de teste (somente alíquotas), se habilitado
  let per_aliq_cbs = toNumberOrZero(reg?.per_aliq_cbs || 0);
  let per_aliq_ibs_est = toNumberOrZero(
    perAliqIbsEstBase?.per_aliq_ibs_est || 0,
  );
  let perAliqIbsMun = toNumberOrZero(perAliqIbsMunBase?.perAliqIbsMun || 0);

  if (empresa.flg_envia_ibs_cbs) {
    per_aliq_cbs = toNumberOrZero(empresa.per_cbs_teste);
    per_aliq_ibs_est = toNumberOrZero(empresa.per_ibs_uf_teste);
    perAliqIbsMun = toNumberOrZero(empresa.per_ibs_mun_teste);
  }

  // 4) Monta o retorno final
  return {
    cod_ibs_cbs: reg.cod_ibs_cbs,
    per_aliq_cbs,
    per_red_cbs: reg.per_red_cbs,
    val_red_social: reg.val_red_social,
    per_aliq_ibs_est,
    per_aliq_ibs_mun: perAliqIbsMun,
    per_red_ibs: toNumberOrZero(perRedIbsBase?.per_red_ibs || 0),
    cst_ibs_cbs: reg.cst_ibs_cbs,
    des_classif_trib_ibs_cbs: reg.des_classif_trib,
  };
};
